import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, of } from 'rxjs';
import { UsersApi } from '../../sdk/services/custom/Users';
import { UtilityService } from '../../services/utility.service';
import { SocketService } from '../../services/socket.service';
import { MessageNotificationSocketService } from '../../services/message-notification-socket.service';
import { Title } from '@angular/platform-browser';
import { AppStateService } from 'shared/services/app-state.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html'
})
export class NotificationComponent implements OnInit, OnDestroy {
    pageTitle: any;
    public notificationLists: Array<any>;
    /*Boot-Datatable params */
    tableData = [];
    loadingIndicator = false;
    itemsPerPage = 10;
    isLoadMore = false;
    itemsPerBatch = 200;
    tableDataCount = 0;
    columns: any;
    allColumns: any;
    noRecords = false;
    page = 1;

    orderBy = 'createdAt DESC';
    currentUser = JSON.parse(localStorage.getItem('appData'));
    accessType:any;
    private generalTableData: Array<any> = [];
    private messageTableData: Array<any> = [];
    private messageNotificationSubscription: Subscription;

    constructor(
        private _utilityService: UtilityService,
        private _socketService: SocketService,
        private _messageNotificationSocketService: MessageNotificationSocketService,
        private _appStateService: AppStateService,
        private _router: Router
    ) { }

    ngOnInit() {
        this.accessType = this._appStateService.getAccessType();
        console.log('access type..', this.accessType);

        this.columns = [
            { name: 'Type', prop: 'type', width: 60, visible: true, sortable: false },
            { name: 'Model Name', prop: 'modelName', width: 150, visible: true, sortable: true },
            { name: 'Title', prop: 'title', width: 400, visible: true, sortable: true, showMore: true },
            { name: 'Message', prop: 'message', width: 400, visible: true, sortable: true, showMore: true },
            { name: 'Notification Time', prop: 'createdAt', width: 170, visible: true, sortable: true },
            { name: 'Action', prop: 'isRead', width: 80, visible: true, sortable: false }
        ];
        this.allColumns = this.columns.slice();

        // this._socketService.getMarkRead().subscribe(data => {
        //     if(data && data.id) {
        //         this.generalTableData.forEach(item => {
        //             if(data.id === item.id) {
        //                 item['isRead'] = true;
        //             }
        //         })
        //     } else {
        //         this.generalTableData.forEach(item => {
        //             item['isRead'] = true;
        //         });
        //     }
        //     this.mergeTableData();
        // });

        this.messageNotificationSubscription = this._messageNotificationSocketService.getMessageNotificationList().subscribe(messageNotification => {
            this.messageTableData = this.modifyMessageData(messageNotification);
            this.mergeTableData();
        });
        // No-op if app-nav-header already started it - ensures unread messages are fetched even
        // if this page loads before the shared socket/notification state has been initialized.
        //this._messageNotificationSocketService.initializeSocket();
    }

    ngOnDestroy() {
        if (this.messageNotificationSubscription) {
            this.messageNotificationSubscription.unsubscribe();
        }
    }

    /**
     *
     * @param page
     */
    getNotification(page) {
        this.loadingIndicator = true;
        this._socketService.getNotificationList(page, this.itemsPerBatch).then(data => {
            const results = this.modifyData(data['data']);
            this.noRecords = (results.length < this.itemsPerBatch) ? true : false;
            if (!this.isLoadMore) {
                this.generalTableData = (results) ? results : [];
            } else {
                if (results.length) {
                    results.forEach(c => {
                        this.generalTableData.push(c);
                    });
                    this.generalTableData = [...this.generalTableData];
                }
            }
            this.mergeTableData();
            this.loadingIndicator = false;

        }, error => {
            this.loadingIndicator = false;
        });


    }

    modifyData(data) {
        if (data.length) {
            data.forEach((item) => {
                item['id'] = (item.activity_id) ? item.activity_id : '';
                item['type'] = (item.action_type) ? item.action_type : '';
                item['modelName'] = (item.entity_name) ? item.entity_name.toUpperCase() : '';
                item['title'] = (item.title) ? item.title : '';
                item['message'] = (item.details) ? item.details : '';
                item['createdAt'] = (item.date_created) ? this._utilityService.dateFormate(item.date_created) : '';
                item['isRead'] = item.marked_read ? 1 : 0;
            });
            return data;
        } else {
            return [];
        }
    }

    /**
     * Reshapes job-message-console notifications into the same row shape modifyData() produces
     * so they render through the same datatable columns as the general notification list.
     */
    modifyMessageData(data) {
        if (data && data.length) {
            return data.map(item => ({
                id: item.id,
                type: 'info',
                modelName: (item.entity_name) ? item.entity_name.toUpperCase() : '',
                title: item.title || '',
                message: item.details || '',
                createdAt: (item.date_created) ? this._utilityService.dateFormate(item.date_created) : '',
                isRead: item.marked_read ? 1 : 0,
                source: 'message'
            }));
        }
        return [];
    }

    private mergeTableData() {
        this.tableData = [...this.messageTableData, ...this.generalTableData];
    }

    // 1 -> itemPerBatch
    loadMoreRecords() {
        this.isLoadMore = true;
        if(this.generalTableData.length === this.page*this.itemsPerBatch) {
            this.page++;
            this.getNotification(this.page);
        }
    }

    toggle(col) {
        col.visible = !col.visible;
    }

    markAsRead(id = null, source = null) {
        if (id) {
            if (source === 'message') {
                this._messageNotificationSocketService.readMessageNotification(id);
            } else {
                //this._socketService.readNotification(id);
            }
            return;
        }
        // this._socketService.readAllNotification();
        this._messageNotificationSocketService.readAllMessageNotification();
    }

    openMessage(row: any): void {
        this._messageNotificationSocketService.readMessageNotification(row.id);
        if (this.accessType === 'vendor') {
            this._router.navigate([
                '/vms/job-message-console/team/purchase-order'
            ]);
        }else{
            this._router.navigate([
                '/vms/job-message-console/team/billing'
            ]); 
        }
    }
}
